import * as React from "react";
import Svg, {
  G,
  Path,
  Defs,
  RadialGradient,
  Stop,
  LinearGradient,
  ClipPath,
  Rect,
} from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={127}
    height={69}
    viewBox="0 0 127 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_997_4842)">
      <Path
        d="M87.305 30.5788V15.7405C87.305 15.1783 87.0817 14.6391 86.6842 14.2416C86.2866 13.8441 85.7475 13.6207 85.1853 13.6207H42.7902C42.228 13.6207 41.6888 13.8441 41.2913 14.2416C40.8937 14.6391 40.6704 15.1783 40.6704 15.7405V30.5788C40.6704 56.0158 63.9877 62.3751 63.9877 62.3751C63.9877 62.3751 87.305 56.0158 87.305 30.5788Z"
        fill="url(#paint0_angular_997_4842)"
      />
      <Path
        d="M63.9877 62.3751L63.5545 63.9635C63.8381 64.0408 64.1373 64.0408 64.4209 63.9635L63.9877 62.3751ZM63.9877 62.3751C64.4209 63.9635 64.4218 63.9632 64.4228 63.963L64.4251 63.9623L64.4315 63.9606L64.4506 63.9552C64.4661 63.9509 64.4872 63.9449 64.5136 63.9372C64.5666 63.9218 64.6411 63.8997 64.7358 63.8704C64.9251 63.8119 65.1951 63.7248 65.5344 63.6058C66.2127 63.368 67.1696 63.0023 68.3123 62.4828C70.5943 61.4456 73.6387 59.7857 76.6889 57.2901C82.8221 52.272 88.9514 43.8841 88.9514 30.5788V15.7405C88.9514 14.7416 88.5546 13.7837 87.8484 13.0774C87.1421 12.3711 86.1841 11.9743 85.1853 11.9743H42.7902C41.7913 11.9743 40.8334 12.3711 40.1271 13.0774C39.4208 13.7837 39.024 14.7416 39.024 15.7405V30.5788C39.024 43.8841 45.1533 52.272 51.2865 57.2901C54.3367 59.7857 57.3811 61.4456 59.6631 62.4828C60.8059 63.0023 61.7628 63.368 62.441 63.6058C62.7803 63.7248 63.0504 63.8119 63.2397 63.8704C63.3343 63.8997 63.4089 63.9218 63.4618 63.9372C63.4733 63.9405 63.4838 63.9436 63.4933 63.9463C63.5056 63.9498 63.5161 63.9528 63.5249 63.9552L63.5439 63.9606L63.5503 63.9623L63.5527 63.963C63.5536 63.9632 63.5545 63.9635 63.9877 62.3751Z"
        stroke="url(#paint1_linear_997_4842)"
        strokeWidth={3.29282}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.4146 35.9825L60.9922 40.5601L71.6733 29.879"
        stroke="white"
        strokeWidth={3.05174}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Path
      d="M110.192 27.6987C106.003 24.287 100.32 15.4685 111.099 7.48779C116.065 11.0722 122.837 20.1325 110.192 27.6987Z"
      fill="url(#paint2_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M109.9 38.5615C108.166 33.4447 108.043 22.9542 121.415 21.9273C123.715 27.6038 124.632 38.8778 109.9 38.5615Z"
      fill="url(#paint3_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M104.206 48.4427C105.032 43.1037 109.768 33.7423 122.103 39.0087C121.521 45.1057 117.126 55.5284 104.206 48.4427Z"
      fill="url(#paint4_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M93.2505 54.2116C96.4867 49.8856 105.064 43.8438 113.482 54.285C110.105 59.3948 101.331 66.5339 93.2505 54.2116Z"
      fill="url(#paint5_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M91.0346 62.0312C90.0559 57.6263 92.071 54.9056 93.237 54.2578C93.7985 54.8624 94.6622 56.2012 94.6622 56.2012C94.6622 56.2012 94.2303 56.6762 94.144 56.8489C91.3455 63.4823 97.3829 64.9678 100.751 64.8815C102.202 65.9179 101.356 66.9544 100.751 67.343C97.9443 67.5158 92.0708 66.6953 91.0346 62.0312Z"
      fill="url(#paint6_linear_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M17.0151 27.6987C21.2041 24.287 26.8873 15.4685 16.1082 7.48779C11.1418 11.0722 4.37027 20.1325 17.0151 27.6987Z"
      fill="url(#paint7_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M17.3071 38.5615C19.0406 33.4447 19.1644 22.9542 5.79179 21.9273C3.49182 27.6038 2.57494 38.8778 17.3071 38.5615Z"
      fill="url(#paint8_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M23.0012 48.4427C22.1751 43.1037 17.439 33.7423 5.10426 39.0087C5.68651 45.1057 10.0811 55.5284 23.0012 48.4427Z"
      fill="url(#paint9_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M33.9565 54.2116C30.7203 49.8856 22.1435 43.8438 13.7254 54.285C17.1022 59.3948 25.8758 66.5339 33.9565 54.2116Z"
      fill="url(#paint10_angular_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Path
      d="M36.173 62.0312C37.1517 57.6263 35.1365 54.9056 33.9705 54.2578C33.4091 54.8624 32.5453 56.2012 32.5453 56.2012C32.5453 56.2012 32.9772 56.6762 33.0635 56.8489C35.862 63.4823 29.8246 64.9678 26.4561 64.8815C25.0051 65.9179 25.8515 66.9544 26.4561 67.343C29.2632 67.5158 35.1367 66.6953 36.173 62.0312Z"
      fill="url(#paint11_linear_997_4842)"
      stroke="white"
      strokeWidth={0.259114}
    />
    <Defs>
      <RadialGradient
        id="paint0_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(64.317 37.9651) rotate(-45) scale(37.086 24.4126)"
      >
        <Stop stopColor="#2D57D9" />
        <Stop offset={1} stopColor="#182E73" />
      </RadialGradient>
      <LinearGradient
        id="paint1_linear_997_4842"
        x1={49.17}
        y1={52.5995}
        x2={76.1712}
        y2={10.7807}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="white" />
        <Stop offset={1} stopColor="#D0D9F6" />
      </LinearGradient>
      <RadialGradient
        id="paint2_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(111.16 17.5932) rotate(95.3729) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <RadialGradient
        id="paint3_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(116.093 30.5179) rotate(127.497) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <RadialGradient
        id="paint4_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(113.414 44.1695) rotate(155.009) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <RadialGradient
        id="paint5_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(103.387 54.7622) rotate(-176.988) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <LinearGradient
        id="paint6_linear_997_4842"
        x1={93.2373}
        y1={55.1647}
        x2={101.529}
        y2={66.6953}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#172C6B" />
        <Stop offset={0.476496} stopColor="#3460EC" />
        <Stop offset={1} stopColor="#4C6DD5" />
      </LinearGradient>
      <RadialGradient
        id="paint7_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.0473 17.5932) rotate(84.6271) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <RadialGradient
        id="paint8_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.1139 30.5179) rotate(52.5027) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <RadialGradient
        id="paint9_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.7927 44.1695) rotate(24.9913) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <RadialGradient
        id="paint10_angular_997_4842"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.8198 54.7622) rotate(-3.01154) scale(10.15 6.28989)"
      >
        <Stop stopColor="#002083" />
        <Stop offset={1} stopColor="#507BFF" />
      </RadialGradient>
      <LinearGradient
        id="paint11_linear_997_4842"
        x1={33.9703}
        y1={55.1647}
        x2={25.6786}
        y2={66.6953}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#172C6B" />
        <Stop offset={0.476496} stopColor="#3460EC" />
        <Stop offset={1} stopColor="#4C6DD5" />
      </LinearGradient>
      <ClipPath id="clip0_997_4842">
        <Rect
          width={67.8322}
          height={67.8322}
          fill="white"
          transform="translate(30.072 0.9021)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
